import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  catchError,
  combineLatest,
  debounceTime,
  filter,
  map,
  of,
  switchMap,
  withLatestFrom
} from 'rxjs';
import { showsPathwaysAndMatches } from '@cpd-app/core-module/constants/routes';
import { Router } from '@angular/router';

import { AppState } from '../index';
import { PathwayCardsActions } from '.';
import { PathwayCardsService } from '../../core-module/services/pathway-card/pathway-cards.service';
import { UserProfileActions, UserProfileSelectors } from '../user-profile';

@Injectable()
export class PathwayCardsEffects {
  constructor(
    private actions$: Actions,
    private pathwayCardsService: PathwayCardsService,
    private store: Store<AppState>,
    private router: Router
  ) {}

  loadPathwayCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        PathwayCardsActions.loadPathwayCards,
        UserProfileActions.saveUserProfileToState
      ),
      debounceTime(500),
      withLatestFrom(
        this.store.select(UserProfileSelectors.selectHasUserProfileBeenSaved)
      ),
      filter(
        ([, isUserProfileSaved]) =>
          isUserProfileSaved && showsPathwaysAndMatches(this.router.url)
      ),
      switchMap(() =>
        combineLatest([this.pathwayCardsService.getPathwaysByCategory()]).pipe(
          map(([pathwayCards]) => {
            return PathwayCardsActions.loadPathwayCardsSuccess({
              pathwayCards: pathwayCards
            });
          }),
          catchError(() => of(PathwayCardsActions.loadPathwayCardsError()))
        )
      )
    )
  );
}
